import { render } from "./PdfEditor.vue?vue&type=template&id=096792e4"
import script from "./PdfEditor.vue?vue&type=script&lang=js"
export * from "./PdfEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__